import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from '../../shared/Card';
import styles from './styles.scss';


const propTypes = {
  notes: PropTypes.string,
  editMode: PropTypes.bool,
  onFieldChange: PropTypes.func
};

const NotesCard = ({ notes, editMode, onFieldChange }) => {
  return (
    <Card header='Notes'>
      <Choose>
        <When condition={editMode}>
          <textarea
            className={`form-control ${styles.noteArea}`}
            onChange={(event) => onFieldChange('notes', event.target.value)}
            rows={5}
            value={notes}/>
        </When>
        <Otherwise>
          <div className={
            classNames(styles.container, {
              [styles.empty]: !notes
            })
          }>
            {notes || 'There are no notes'}
          </div>
        </Otherwise>
      </Choose>
    </Card>
  );
};

NotesCard.propTypes = propTypes;

export default NotesCard;



// WEBPACK FOOTER //
// src/components/testDetails/NotesCard/index.jsx